<script lang="ts">
    //+page file needed so that layout with ListAndWordCard doesn't rerender
    import {page} from '$app/state';

    let {data} = $props();

    let {browseNavigator} = data

    // initial navigation when opening route
    browseNavigator.navigateViaWordId(page.params.wordId, true)
</script>

<svelte:window onpopstate={() => browseNavigator.navigateViaWordId(page.params.wordId, true)}/>